import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';

interface LeftPanelProps {
  selectedMenu: string | null;
  setSelectedMenu: (menu: string | null) => void;
}

const LeftPanel: React.FC<LeftPanelProps> = ({ selectedMenu, setSelectedMenu }) => {
  return (
    <Box
      sx={{
        width: 240,
        minWidth: 240,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Sidebar selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
    </Box>
  );
};

export default LeftPanel;
